"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MPWContinueToUse = void 0;
var MPWContinueToUse;
(function (MPWContinueToUse) {
    MPWContinueToUse["YES"] = "YES";
    MPWContinueToUse["MAYBE"] = "MAYBE";
    MPWContinueToUse["NO"] = "NO";
})(MPWContinueToUse || (exports.MPWContinueToUse = MPWContinueToUse = {}));
